import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private _isAuthenticated = signal(!!this.get('token'));
  readonly isAuthenticated = this._isAuthenticated.asReadonly();

  get<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
    if (key === 'token') {
      this._isAuthenticated.set(true);
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
    if (key === 'token') {
      this._isAuthenticated.set(false);
    }
  }

  clear(): void {
    localStorage.clear();
    this._isAuthenticated.set(false);
  }

  clearCredentials(): void {
    this.remove("token");
    this.remove("username");
    this.remove("email");
  }
}
